import { right } from '@popperjs/core';
import Vue from 'vue';
export default Vue.component('ed-tooltip', { 
  name: 'ed-tooltip',
  props: {
    position: {
      type: String,
      validator: value => ['top', 'bottom', 'left', 'right', 'bottom-custom'].includes(value),
    },
    offset: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    tooltipTextChanges: {
      type: String,
      default: ''
    }
  },
  watch: {
    tooltipTextChanges(oldVal, newVal) {
      if(oldVal && newVal && oldVal !== newVal) {
        this.tooltipChanged = true;
        this.hideTooltip();
      }
    }
  },
  data() {
    return {
      visible: false,
      tooltipStyle: {},
      tooltipChanged: false
    };
  },
  methods: {
    showTooltip(event) {
      if (this.disabled) {
        return;
      }

      this.visible = true;
      this.$nextTick(() => {
        const trigger = event.currentTarget;
        const tooltip = this.$el.querySelector('.ed-tooltip');
        if (trigger && tooltip) {
          const triggerRect = trigger.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          let top, left;

          switch (this.position) {
            case 'top':
              top = triggerRect.top - (tooltipRect.height * 2)  - this.offset;
              left = triggerRect.left + (triggerRect.width / 2) - tooltipRect.width;
              
              break;
              
            case 'bottom':
              top = triggerRect.bottom + this.offset;
              left = triggerRect.left + (triggerRect.width / 2) - tooltipRect.width;
              if (triggerRect.x - tooltipRect.width < 0) {
                left = 0;
              }

              if (triggerRect.right + (tooltipRect.width) > window.innerWidth) {
                left = window.innerWidth - tooltipRect.width * 2 - 15;
              }
              
              break;

            case 'bottom-custom':
              top = triggerRect.bottom + this.offset;
              left = triggerRect.left + (triggerRect.width / 2) - tooltipRect.width;
              if (left < 0) {
                left = 0;
              }

              if (left + tooltipRect.width > window.innerWidth) {
                left = window.innerWidth - tooltipRect.width - 15; // 15 is margin
              }
              
              break;

            case 'left':
              top = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
              left = triggerRect.left - tooltipRect.width - this.offset;
              break;

            case 'right':
              top = triggerRect.top - (tooltipRect.height / 2);
              left =  triggerRect.right + this.offset;
              if (triggerRect.right + (tooltipRect.width * 2) > window.innerWidth) {
                left = window.innerWidth - tooltipRect.width * 2 - 20;
              }

              break;

              default:
                top = triggerRect.y;
                left = 0;
                break;
          }

          this.tooltipStyle = {
            top: `${top}px`,
            left: `${left}px`,
          };
        }
      });
    },
    handleClick(event) {
      if(this.tooltipTextChanges && this.tooltipChanged) {
        this.showTooltip(event);
        this.tooltipChanged = false;
      }
    },
    hideTooltip() {
      this.visible = false;
    },
  },
});